
<dashboard-card [title]="'CheckUps'" [soFarAchieved]="finishedFollowups" [dailyTarget]="minFollowupsToDone" [diffInDays]="diffInDays" [dataItems]="dataItems"></dashboard-card>